import { useEffect, useState } from "react";
import QRCode from "qrcode";

/**
 * The Creator Pass: a white perforated ticket stub carrying the creator's
 * handle and QR. On the landing page it's a sample; in the dashboard it's the
 * creator's real code (pass `qrSrc` from the server).
 */
export default function CreatorPass({ handle = "@yourhandle", meta = "Creator Partner · Los Angeles", code = "Your code", qrValue, qrSrc, hint }) {
  const [svg, setSvg] = useState("");
  useEffect(() => {
    if (qrSrc || !qrValue) return;
    QRCode.toString(qrValue, { type: "svg", margin: 0, errorCorrectionLevel: "M", color: { dark: "#000000", light: "#ffffff" } })
      .then(setSvg)
      .catch(() => setSvg(""));
  }, [qrValue, qrSrc]);

  return (
    <div className="cp-pass" role="img" aria-label={`InstaPass Creator Pass for ${handle}`}>
      <div className="cp-pass-top">
        <div className="cp-pass-brand">
          <b>INSTAPASS</b>
          <span>Creator Pass</span>
        </div>
        <div className="cp-pass-handle">{handle}</div>
        <div className="cp-pass-meta">{meta}</div>
      </div>
      <div className="cp-pass-perf" aria-hidden="true" />
      <div className="cp-pass-stub">
        {qrSrc ? <img src={qrSrc} alt="" /> : <span aria-hidden="true" dangerouslySetInnerHTML={{ __html: svg }} />}
        <div>
          <div className="code">{code}</div>
          <div className="hint">{hint || "Scan to buy tickets. Every verified sale is credited to you."}</div>
        </div>
      </div>
    </div>
  );
}
